import request from '../../axios';

const getCardDetail = async (bank_name?: string) => {
  const {data}: {data: ICardNumber[]} = await request.get(
    `api/v2/subscription/card-number`,
    {params: {bank_name}},
  );
  return data;
};

export {getCardDetail};
